// ─────────────────────────────────────────────────────────
// Codificação/decodificação do valor embutido no QR de presença.
//
// Formato: P + código + 1 dígito verificador.
// O código pode ter 4, 6 ou 8 caracteres.
// ─────────────────────────────────────────────────────────

const CHECKSUM_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";

function computeCheckChar(code) {
  let sum = 0;
  for (let i = 0; i < code.length; i++) {
    sum += code.charCodeAt(i) * (i + 1);
  }
  return CHECKSUM_CHARS[sum % CHECKSUM_CHARS.length];
}

export function encodePresenceQrValue(presenceCode) {
  const code = presenceCode.trim().toUpperCase();
  return `P${code}${computeCheckChar(code)}`;
}

// Retorna o PresenceCode puro se o valor lido for íntegro,
// ou null se for uma leitura inválida/corrompida.
export function decodePresenceQrValue(rawText) {
  let value = rawText.trim();

  // Compatibilidade: se ainda existir algum QR no formato antigo
  // (URL com ?code=), extrai daí antes de seguir.
  try {
    const url = new URL(value);
    value = url.searchParams.get("code") || value;
  } catch {
    // Não é URL — segue com o texto puro.
  }

  value = value.toUpperCase().replace(/[^A-Z0-9]/g, "");

  // AGORA SUPORTA 4, 6 ou 8 caracteres
  // P + código (4, 6 ou 8 chars) + 1 dígito verificador
  const match = value.match(/^P([A-Z0-9]{4,8})([0-9A-Z])$/);

  if (!match) {
    // Tenta também sem o prefixo P (fallback)
    const fallbackMatch = value.match(/^([A-Z0-9]{4,8})([0-9A-Z])$/);
    if (fallbackMatch) {
      const [, code, checkChar] = fallbackMatch;
      if (computeCheckChar(code) === checkChar) {
        return code;
      }
    }
    return null;
  }

  const [, code, checkChar] = match;

  if (computeCheckChar(code) !== checkChar) {
    return null; // dígito verificador não bate — leitura corrompida
  }

  return code;
}